import {
  Button,
  createStyles,
  makeStyles,
  Theme,
  Tooltip,
  Typography,
} from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  setVideoSessionEvidenceAddFormEnabled(): void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonText: {
      textTransform: "capitalize",
      color: "white",
    },
  }),
);

export const AddVideoSessionEvidenceButton: FC<Props> = ({
  setVideoSessionEvidenceAddFormEnabled,
}) => {
  const { t } = useTranslation("audits");
  const classes = useStyles();

  const handleAddVideoSessionEvidenceClick = () => {
    setVideoSessionEvidenceAddFormEnabled();
  };

  return (
    <>
      <Tooltip title={t<string>("addVideoSessionEvidenceTooltip")} arrow={true}>
        <Button
          onClick={() => handleAddVideoSessionEvidenceClick()}
          className={classes.buttonText}
        >
          <AddCircleOutlineIcon style={{ fill: "white", fontSize: 28 }} />
          <Typography variant="body1">{t("addVideoEvidence")}</Typography>
        </Button>
      </Tooltip>
    </>
  );
};
